import "./lib/css/reset/reset.css.mjs";
import "./lib/css/atoms/sprinkles.css.mjs";
import { markResetImported } from "./lib/css/reset/resetTracker.mjs";
if (process.env.NODE_ENV === "development") {
  markResetImported();
}
